import * as t from '../action_types';

// Generic key-value setter for the support-inbox slice (house pattern).
export const set_support_variable = (key, payload) => ({
  type: t.set_support_variable,
  payload: {
    key,
    payload
  }
});

// GET /v2/support/bootstrap → teams, agents, tags, views, folder_counts.
export const get_support_bootstrap = () => ({
  type: t.get_support_bootstrap
});

// GET /v2/support/conversations — payload: { folder, status, sort, limit, offset }.
export const get_support_conversations = (payload) => ({
  type: t.get_support_conversations,
  payload
});

// GET /v2/support/conversations/:uuid — payload: { uuid }.
export const get_support_conversation = (payload) => ({
  type: t.get_support_conversation,
  payload
});

// POST /v2/support/conversations — payload: { body, refresh }.
// Creates a new agent-initiated outbound conversation (New conversation modal).
export const create_support_conversation = (payload) => ({
  type: t.create_support_conversation,
  payload
});

// POST /v2/support/conversations/:uuid/read — payload: { uuid }.
export const mark_support_read = (payload) => ({
  type: t.mark_support_read,
  payload
});

// POST /v2/support/conversations/:uuid/reply — payload: { uuid, body, refresh }.
export const send_support_reply = (payload) => ({
  type: t.send_support_reply,
  payload
});

// PATCH /v2/support/conversations/:uuid — payload: { uuid, patch, refresh }.
export const patch_support_conversation = (payload) => ({
  type: t.patch_support_conversation,
  payload
});

// PUT /v2/support/conversations/:uuid/tags — payload: { uuid, tags }.
export const replace_support_tags = (payload) => ({
  type: t.replace_support_tags,
  payload
});

// POST /v2/support/conversations/:uuid/notes — payload: { uuid, body, mentions, attachment_ids }.
export const add_support_note = (payload) => ({
  type: t.add_support_note,
  payload
});

// POST/PUT /v2/support/views — payload: { method, uuid, body }.
export const save_support_view = (payload) => ({
  type: t.save_support_view,
  payload
});

// DELETE /v2/support/views/:uuid — payload: { uuid }.
export const delete_support_view = (payload) => ({
  type: t.delete_support_view,
  payload
});

// GET /v2/support/search?q= — payload: { q }.
export const search_support = (payload) => ({
  type: t.search_support,
  payload
});
